import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import classNames from 'classnames';

import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';

import Start from '@material-ui/icons/Star';
import Mail from '@material-ui/icons/Mail';
import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class MenuValue extends React.Component {

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleSearch = (id, name) => event => {
        this.props
            .loadSTS(
                id,
                undefined,
                undefined,
                name
            )
            .then(() => this.props.history.push('/reports/sts/result'))
            .catch((error) => {
                this.setState({ error: error.message });
            });
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    render() {
        const { intl, locals, locals_is_loading } = this.props;
        const data = locals && locals.length > 0 ? locals.filter((l) => l.stsEncuesta).sort((a, b) => (a.nombre < b.nombre ? -1 : 1)) : [];

        return (
            <div className="flex_full_column overflow_y_scroll">
                {locals_is_loading && <Loading open opacity />}
                {   data.length > 0
                    ?
                        data.map((local, index) => {
                            return (
                                <div
                                    key={randomstring()}
                                    className={'flex_auto_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand '}
                                    onClick={this.handleSearch(local.id, local.nombre)}
                                >
                                    <div
                                        className={classNames(
                                            'flex_full_row  align_center padding_bottom_9',
                                            data.length === index + 1 ? 'noshadow' : 'shadow_down',
                                        )}
                                    >
                                        <div className={'flex_full_row'}>
                                            <span className="flex_full_row barlow_medium c_dark_grey_blue uppercase">
                                                {local.nombre}
                                            </span>
                                            <div className="flex_auto_row align_center">
                                                <Hidden xsDown>
                                                    <span className="margin_right_6 nowrap c_black">{intl.formatMessage({ id: 'sts_survey_total' })}</span>
                                                    <Mail className={"c_pea "} />
                                                    <span className="margin_right_6 min_width_32 text_align_right">{local.votosSts}</span>
                                                    <Start className={"c_golden_yellow "} />
                                                    <span className="margin_right_12 min_width_24 text_align_right">{(Math.round(local.puntuacionSts * 10) / 10).toFixed(1)}</span>
                                                </Hidden>
                                                <span className="margin_right_6 nowrap c_black">{intl.formatMessage({ id: 'sts_survey_2w' })}</span>
                                                <Mail className={"c_pea "} />
                                                <span className="margin_right_6 min_width_32 text_align_right">{local.votosSts}</span>
                                                <Start className={"c_golden_yellow "} />
                                                <span className="margin_right_6 min_width_24 text_align_right">{(Math.round(local.puntuacionSts * 10) / 10).toFixed(1)}</span>
                                            </div>
                                        </div>
                                        <BlueRightArrowIcon color="primary" />
                                    </div>
                                </div>
                            );
                        })
                    : <Error open type="warning" id={"empty"} handleClose={this.handleBack} />
                }
            </div>
        );
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired
};

export default injectIntl(MenuValue);



// WEBPACK FOOTER //
// ./src/components/complex/reports/sts/Menu.js